import React from "react";
import { Card, Form, Row, Col, Button, Image } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const PolicySection = ({ data, onUpdate }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({
      ...data,
      [field]: value
    });
  };

  const handleFileUpload = async (field, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleChange(field, res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  const handleInitiativesChange = (index, value) => {
    const initiatives = [...data.initiatives];
    initiatives[index] = value;
    handleChange("initiatives", initiatives);
  };

  const handleAddInitiative = () => {
    const initiatives = [...data.initiatives];
    initiatives.push("");
    handleChange("initiatives", initiatives);
  };

  const handleRemoveInitiative = (index) => {
    const initiatives = [...data.initiatives];
    initiatives.splice(index, 1);
    handleChange("initiatives", initiatives);
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Policy Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading}
                  onChange={(e) => handleChange('heading', e.target.value)}
                  placeholder="Enter heading"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={data.description}
                  onChange={(e) => handleChange('description', e.target.value)}
                  placeholder="Enter description"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Image</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files?.[0] && handleFileUpload('image', e.target.files[0])
                  }
                />
                {isUploading && (
                  <div className="text-muted small mt-1">Uploading...</div>
                )}
                {data.image && (
                  <div className="mt-2">
                    <Image src={data.image} thumbnail style={{ maxWidth: "200px" }} />
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6>Initiatives</h6>
            <Button variant="outline-primary" size="sm" onClick={handleAddInitiative}>
              Add Initiative
            </Button>
          </div>

          {data.initiatives.map((initiative, index) => (
            <div key={index} className="border rounded p-3 mb-3 bg-light-subtle">
              <Row>
                <Col md={10}>
                  <Form.Control
                    type="text"
                    placeholder="Initiative"
                    value={initiative}
                    onChange={(e) => handleInitiativesChange(index, e.target.value)}
                  />
                </Col>
                <Col md={2}>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleRemoveInitiative(index)}
                  >
                    Remove
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
        </Card.Body>
      )}
    </Card>
  );
};

export default PolicySection;
